import { CASEMASTERS_ANDROID_APP_URL, CASEMASTERS_IOS_APP_URL } from "../../constants/urls";
import { MOBILE_OSES } from "../../constants";
import playstore from "./assets/playstore.png";
import appstore from "./assets/appstore.png";
import mixpanel from "../../services/mixpanel";

export const getPlatformData = mobileOS => {
  switch (mobileOS) {
    case MOBILE_OSES.ANDROID:
      return {
        appIconClassName: "-android",
        storeIcon: playstore,
        storeName: "PlayStore",
        platformName: "Android",
        appUrl: CASEMASTERS_ANDROID_APP_URL,
      };
    case MOBILE_OSES.IOS:
      return {
        appIconClassName: "-ios",
        storeIcon: appstore,
        storeName: "AppStore",
        platformName: "iOS",
        appUrl: CASEMASTERS_IOS_APP_URL,
      };
    default:
      return null;
  }
};

export const trackDownloadApp = () => {
  mixpanel.track("downloadapp.download");
};



// WEBPACK FOOTER //
// ./src/components/DownloadAppDialog/util.js